
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Puneto5jyotilingadarshancab() {



    const cardData =
    {
        keyword: 'Pune to 5 Jyotirlinga Darshan Cab',
        heading: 'Mauli Cabs: Pune to 5 Jyotirlinga Darshan Cab',
        headingDescription: 'Mauli Cabs offers a Pune to 5 Jyotirlinga Darshan cab service, providing a comfortable and spiritual journey to visit the five sacred Jyotirlinga temples located in Maharashtra. Whether you are embarking on a pilgrimage or seeking spiritual enlightenment, our well-maintained vehicles, including sedans, SUVs, and premium cabs, ensure a smooth and comfortable ride. Our professional drivers are experienced in the routes and will ensure timely and safe travel between the temples.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Grishneshwar Temple",
        "description": "Located in Ellora near Aurangabad, Grishneshwar is the 12th and the last Jyotirlinga of India. It’s dedicated to Lord Shiva and is an important pilgrimage site for devotees."
    },
    {
        "title": "Trimbakeshwar Temple",
        "description": "Located in Trimbak, near Nashik, this temple is one of the most revered Jyotirlingas. The temple’s unique feature is the three-faced Shiva Linga representing Brahma, Vishnu, and Shiva."
    },
    {
        "title": "Aundha Nagnath Temple",
        "description": "Situated in the Aundha village in Maharashtra, Aundha Nagnath is one of the significant Jyotirlinga temples, dedicated to Lord Shiva and attracts thousands of pilgrims."
    },
    {
        "title": "Bhima Shankar Temple",
        "description": "Located in the Sahyadri hills near Pune, Bhimashankar is the sixth Jyotirlinga and is surrounded by dense forests. It is famous for its breathtaking natural beauty and historical significance."
    },
    {
        "title": "Vaijnath Temple",
        "description": "Situated in Parli, Maharashtra, Vaijnath is another significant Jyotirlinga. The temple has deep religious importance and is known for its tranquil surroundings and architectural beauty."
    }
],

"services": [
    {
      "name": "Pune to 5 Jyotirlinga Darshan Cab",
      "description": "Embark on a divine journey to visit the five revered Jyotirlingas from Pune. This comprehensive package includes transportation to Bhimashankar, Trimbakeshwar, Grishneshwar, Vaijnath, and Aundha Nagnath. The service provides comfortable vehicles with experienced drivers to ensure a smooth and peaceful pilgrimage. It is ideal for those who wish to complete their Jyotirlinga darshan in a single trip, enjoying both the spiritual significance and scenic beauty along the way."
    },
    {
      "name": "Pune to Bhimashankar Cab",
      "description": "Bhimashankar, located around 110 kilometers from Pune, is one of the twelve sacred Jyotirlingas in India. Our Pune to Bhimashankar cab service offers a comfortable and hassle-free journey, ensuring you can enjoy your pilgrimage without any worries. Our cabs are equipped with air conditioning and spacious seating, perfect for a relaxing ride. Whether you’re traveling solo, with family, or in a group, we provide the right vehicle to meet your needs."
    },
    {
      "name": "Pune to Bhimashankar Taxi Fare",
      "description": "The fare for a taxi from Pune to Bhimashankar is budget-friendly and varies based on the type of vehicle you choose. The price generally depends on factors such as vehicle size, duration of travel, and any additional services. For your convenience, we offer both one-way and round-trip fares. Whether you’re traveling in a sedan, SUV, or luxury car like an Innova, we ensure transparency in pricing with no hidden charges."
    },
    {
      "name": "Taxi from Pune to Bhimashankar",
      "description": "Our taxi service from Pune to Bhimashankar guarantees a smooth and safe ride. Our fleet includes well-maintained vehicles driven by professional chauffeurs, ensuring a pleasant journey to the sacred temple. Whether you're going for a day trip or an overnight stay, we provide flexible packages. The cab is equipped with all necessary amenities, ensuring comfort during the ride, which lasts around 2.5 to 3 hours."
    },
    {
      "name": "Taxi Service from Pune to Bhimashankar",
      "description": "Choose our reliable taxi service for a trip to Bhimashankar, one of the most important spiritual destinations in Maharashtra. We offer vehicles that are well-suited for long-distance travel, including air-conditioned options for added comfort. Our drivers are experienced and well-versed in the route to ensure a safe and timely journey. You can also request additional services, such as a guide for the temple visit, upon booking."
    },
    {
      "name": "Pune to Bhimashankar Taxi Service",
      "description": "Our Pune to Bhimashankar taxi service is designed to offer a comfortable and stress-free experience for pilgrims and tourists alike. We offer a range of vehicles from budget to premium options, including SUVs and sedans. Our experienced drivers take the safest and most efficient routes, ensuring that you arrive on time to enjoy the darshan at Bhimashankar Temple."
    },
    {
      "name": "Pune to Bhimashankar Cab Price",
      "description": "The price for a cab from Pune to Bhimashankar is reasonable, with options to suit various budgets. Prices typically start from affordable sedan rates, going up to luxury SUV and Innova rental options. We provide transparent pricing with no hidden fees and offer both one-way and round-trip packages. Discounts may apply for group bookings, corporate trips, or long-distance rentals."
    },
    {
      "name": "Pune to Trimbakeshwar Cab",
      "description": "Trimbakeshwar, located near Nashik, is another important Jyotirlinga and is approximately 160 km away from Pune. Our cab service offers a comfortable and easy way to travel to Trimbakeshwar, with door-to-door pick-up and drop-off services. We have a variety of vehicle options depending on your group size and preferences, from sedans to larger vehicles for family trips."
    },
    {
      "name": "Pune to Trimbakeshwar Cab Fare",
      "description": "The fare for a taxi from Pune to Trimbakeshwar depends on the vehicle type, distance, and duration of the trip. Typically, fares start from affordable sedan rates and increase with larger vehicles like SUVs or Innova. We offer competitive pricing with no hidden charges, and our transparent fare structure ensures you know exactly what you’re paying for."
    },
    {
      "name": "Pune to Trimbakeshwar Car Rental",
      "description": "Rent a car from Pune to Trimbakeshwar and enjoy a hassle-free pilgrimage experience. Our rental cars are available in various types, from basic sedans to spacious SUVs, catering to individuals, families, and groups. With our reliable car rental service, you can explore Trimbakeshwar at your own pace, without worrying about public transport schedules or parking issues."
    },
    {
      "name": "Pune to Trimbakeshwar Taxi",
      "description": "Book a taxi from Pune to Trimbakeshwar and experience a comfortable and safe journey. Our taxis are driven by professional and experienced chauffeurs who are familiar with the best routes to Trimbakeshwar. Whether you need a one-way trip or round-trip taxi service, we provide flexible packages to suit your travel preferences."
    },
    {
      "name": "Pune to Trimbakeshwar Taxi Fare",
      "description": "Taxi fares for trips from Pune to Trimbakeshwar are affordable and competitive. The cost depends on the vehicle type, duration of the trip, and the number of passengers. We offer a range of options from standard sedans to larger SUVs and taxis, ensuring you get the best value for your money."
    },
    {
      "name": "Trimbakeshwar to Pune Cab",
      "description": "Book a return cab from Trimbakeshwar to Pune with our seamless service. Whether you’re finishing your darshan or taking a scenic trip back to Pune, our cabs ensure a comfortable ride. Choose from our fleet of well-maintained vehicles and enjoy a smooth ride back to Pune, with expert drivers who know the safest and fastest routes."
    },
    {
      "name": "Pune to Grishneshwar Cab",
      "description": "Travel from Pune to Grishneshwar, one of the twelve Jyotirlingas, with our premium cab service. Grishneshwar, located near Ellora, is a significant pilgrimage site, and we offer safe and comfortable cab services to get you there. Enjoy a peaceful and scenic journey to this sacred destination with our experienced drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Grishneshwar Cab Service",
      "description": "Book a reliable cab from Pune to Grishneshwar, home to another sacred Jyotirlinga. Our cabs are well-equipped for long-distance travel, offering comfort, safety, and efficiency. Whether you're traveling for a one-day visit or an extended tour, our taxi service offers flexibility and comfort."
    },
    {
      "name": "Pune to Grishneshwar Jyotirlinga Cab",
      "description": "Take a spiritual journey to Grishneshwar with our convenient cab service. Book a private cab for a hassle-free journey from Pune to Grishneshwar, located near the famous Ellora caves. The journey offers scenic views and a peaceful atmosphere, ideal for those looking to combine their spiritual visit with a relaxing experience."
    },
    {
      "name": "Pune to Aundha Nagnath Cab",
      "description": "Aundha Nagnath is a sacred pilgrimage site located in Haryana, and our cab service from Pune ensures a smooth, hassle-free trip to this spiritual destination. We offer both one-way and round-trip services, with comfortable vehicles that provide ample space for your journey."
    },
    {
      "name": "Pune to Vaijnath Jyotirlinga Darshan",
      "description": "Book a cab to visit the Vaijnath Jyotirlinga, an important religious site located in Maharashtra. Our taxi service from Pune to Vaijnath provides an easy and comfortable journey, ensuring that your pilgrimage is both memorable and convenient."
    },
    {
      "name": "Pune to Vaijnath Jyotirlinga Darshan Cab",
      "description": "For your darshan at Vaijnath Jyotirlinga, our dedicated cab services offer a peaceful and efficient ride. We ensure timely pickups, comfortable travel, and a smooth journey. Whether you're planning a one-day trip or an extended stay, we offer flexible packages to cater to your needs."
    }
  ],
  "tableData": [
    ["Pune to 5 Jyotirlinga Darshan Cab", "Pune to Bhimashankar Cab"],
    ["Pune to Bhimashankar Taxi Fare", "Taxi from Pune to Bhimashankar"],
    ["Taxi Service from Pune to Bhimashankar", "Pune to Bhimashankar Taxi Service"],
    ["Pune to Bhimashankar Cab Price", "Pune to Trimbakeshwar Cab"],
    ["Pune to Trimbakeshwar Cab Fare", "Pune to Trimbakeshwar Car Rental"],
    ["Pune to Trimbakeshwar Taxi", "Pune to Trimbakeshwar Taxi Fare"],
    ["Trimbakeshwar to Pune Cab", "Pune to Grishneshwar Cab"],
    ["Pune to Grishneshwar Cab Service", "Pune to Grishneshwar Jyotirlinga Cab"],
    ["Pune to Aundha Nagnath Cab", "Pune to Vaijnath Jyotirlinga Darshan"],
    ["Pune to Vaijnath Jyotirlinga Darshan Cab"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Pune to 5 Jyotirlinga Darshan Cab",
        "WhyChoosedescription": "Mauli Cabs offers dedicated cab services for the spiritually enriching 5 Jyotirlinga Darshan from Pune. Travel to the sacred shrines in comfort and convenience with our specially curated pilgrimage packages."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles for Long Travel",
        "WhyChoosedescription": "We provide well-maintained sedans, SUVs, and Tempo Travellers for long-distance religious tours. Enjoy a peaceful and relaxed journey to the Jyotirlingas with plenty of legroom and luggage space."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with Pilgrimage Routes",
        "WhyChoosedescription": "Our drivers are experienced with religious circuits and understand the routes to Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath Jyotirlingas—ensuring timely and safe travel."
    },
    {
        "WhyChooseheading": "Customizable Packages with Itinerary Planning",
        "WhyChoosedescription": "We offer customizable Jyotirlinga tour packages that can be tailored to your preferred dates and schedule. Our team assists with planning the most efficient and spiritually fulfilling travel itinerary."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers competitive rates with complete transparency—no hidden charges. Our pilgrimage cab packages offer great value for money for both small groups and large families."
    },
    {
        "WhyChooseheading": "24/7 Support and Assistance",
        "WhyChoosedescription": "Our support team is available around the clock to assist you throughout the journey—from booking to the final drop. Get real-time updates, travel guidance, and responsive customer service at every step."
    },
    {
        "WhyChooseheading": "Sanitized, GPS-Enabled Cabs for a Safe Journey",
        "WhyChoosedescription": "All vehicles are regularly sanitized, GPS-enabled, and driven by background-verified drivers. We follow strict hygiene and safety protocols to ensure a secure pilgrimage experience."
    },
    {
        "WhyChooseheading": "Flexible Payment Options",
        "WhyChoosedescription": "Choose from multiple payment options such as UPI, credit/debit cards, wallets, or cash for easy and flexible booking of your 5 Jyotirlinga Darshan cab from Pune."
    }
]











    }

    const faqData = [
        {
            question: 'How can I book a cab from Pune for 5 Jyotirlinga Darshan?',
            answer: 'Booking a cab for the 5 Jyotirlinga Darshan tour from Pune is easy with Mauli Cabs. Visit our website or mobile app, choose your vehicle type, and select "5 Jyotirlinga Darshan" as the destination. You can also contact our customer support for customized itineraries and bookings.',
        },
        {
            question: 'Which Jyotirlingas are covered in the Pune to 5 Jyotirlinga Darshan trip?',
            answer: 'The 5 Jyotirlingas covered from Pune usually include Bhimashankar, Trimbakeshwar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. The route can be customized based on your preferences and travel schedule.',
        },
        {
            question: 'How many days does the 5 Jyotirlinga Darshan trip from Pune take?',
            answer: 'The complete 5 Jyotirlinga Darshan trip from Pune generally takes 3 to 5 days, depending on travel speed, halt duration at each temple, and the route taken. Our team can help plan the itinerary for a comfortable journey.',
        },
        {
            question: 'What types of vehicles are available for this pilgrimage tour?',
            answer: 'Mauli Cabs offers Hatchbacks, Sedans, SUVs, Innova Crysta, Ertiga, and Tempo Travellers for the 5 Jyotirlinga Darshan trip. Choose a vehicle based on your group size, luggage, and comfort needs.',
        },
        {
            question: 'Is the pricing fixed for the Pune to 5 Jyotirlinga Darshan cab?',
            answer: 'Yes, we offer fixed and transparent pricing for the full 5 Jyotirlinga Darshan package from Pune. The fare includes fuel, tolls, driver charges, and taxes with no hidden costs. Customized packages are also available.',
        },
        {
            question: 'Can I customize the itinerary or add stops during the Jyotirlinga trip?',
            answer: 'Yes, the itinerary is fully customizable. You can add stops, extend your stay at specific locations, or modify routes. Just inform our team at the time of booking for a personalized travel plan.',
        },
        {
            question: 'Are Mauli Cabs drivers familiar with the temple routes and timings?',
            answer: 'Yes, our drivers are experienced and well-versed with temple routes, timings, and travel guidelines. They ensure your journey is safe, timely, and aligned with temple darshan schedules.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Mahadev Shinde",
            position: "Retired Banker",
            text: "We booked a cab for 5 Jyotirlinga Darshan from Pune. The driver was very knowledgeable about the routes and temple timings. The vehicle was clean and comfortable. We had a divine and peaceful journey. Thank you, Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-113.png",
        },
        {
            name: "Mrs. Kalpana Pawar",
            position: "Homemaker",
            text: "Mauli Cabs arranged a smooth and comfortable trip for our 5 Jyotirlinga pilgrimage. The driver was helpful and respectful, and the entire journey was well-managed. Highly recommended for spiritual tours!",
            image: "/img/testimonial/testimonial-thumb-1-114.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to 5 Jyotirlinga Darshan Cab",
        "description": "Book a reliable and comfortable cab service for your Pune to 5 Jyotirlinga Darshan tour. Visit Bhimashankar, Trimbakeshwar, Grishneshwar, Vaijnath, and Aundha Nagnath with our affordable taxi services.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "150"
        },
        "offers": {
          "@type": "Offer",
          "url": "https://www.maulicabs.com/pune-to-5-jyotirlinga-darshan-cab",
          "priceCurrency": "INR",
          "price": "10000",
          "priceValidUntil": "2025-12-31"
        }
      };
      
 


    return (
        <div>
            <GTag/>


<Helmet>
        <title>Pune to 5 Jyotirlinga Darshan Cab | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book a comfortable and affordable cab service from Pune for a Jyotirlinga Darshan tour covering Bhimashankar, Trimbakeshwar, Grishneshwar, Vaijnath, and Aundha Nagnath. Get competitive pricing and personalized service."
        />
        <meta
          name="keywords"
          content="Pune to 5 Jyotirlinga Darshan cab, Pune to Bhimashankar cab, Pune to Trimbakeshwar taxi, Grishneshwar Jyotirlinga tour, Pune to Aundha Nagnath cab, Vaijnath Jyotirlinga darshan taxi, taxi service Pune to Jyotirlinga"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>
      

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/140.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneto5jyotilingadarshancab;